import { Fragment } from 'react';
import format from './format';
import numberFormatter from './numberFormatter';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const formatNewLine = trlValue => {
  const splitValues = trlValue.split(/\n/gi);
  const lastIndex = splitValues.length - 1;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: splitValues.map((row, index) => /*#__PURE__*/_jsxs(Fragment, {
      children: [row, index < lastIndex && /*#__PURE__*/_jsx("br", {})]
    }, index))
  });
};
const formatToReactComponent = (trlValue, formatValues) => {
  const originalTrlValue = trlValue;
  Object.keys(formatValues).forEach((value, index) => {
    trlValue = trlValue.replace(value, `#${index}#`);
  });
  const splitByDivider = trlValue.split(new RegExp(Object.keys(formatValues).map((item, index) => `#${index}#`).join('|'), 'g'));
  const sortedFormatValues = Object.keys(formatValues).map(value => ({
    index: originalTrlValue.indexOf(value),
    value: formatValues[value]
  })).filter(item => item.index !== -1).sort((a, b) => a.index - b.index);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: splitByDivider.map((value, index) => /*#__PURE__*/_jsxs(Fragment, {
      children: [value, index !== splitByDivider.length - 1 && sortedFormatValues[index].value]
    }, index))
  });
};
const formatFromTo = ({
  from,
  to
}, {
  trlFrom,
  trlTo,
  trlFromTo
}, formatterParams) => {
  if (from && to) {
    return format(trlFromTo, {
      '{0}': numberFormatter.format(from.toString(), formatterParams),
      '{1}': numberFormatter.format(to.toString(), formatterParams)
    });
  }
  if (to) {
    return format(trlTo, {
      '{0}': numberFormatter.format(to.toString(), formatterParams)
    });
  }
  if (from) {
    return format(trlFrom, {
      '{0}': numberFormatter.format(from.toString(), formatterParams)
    });
  }
  return null;
};
export { numberFormatter, format, formatToReactComponent, formatNewLine, formatFromTo };
//# sourceMappingURL=index.js.map